/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from "prop-types";
import { jsx } from '@emotion/core';
const Grid = ({
  getX,
  getY,
  gridColor,
  GridLines,
  gridWidth,
  labelsCountY,
  maxX,
  maxY,
  minX,
  minY,
  unitWidth
}) => {
  let gridX = [];
  let gridY = [];
  for (let i = minX; i <= maxX + unitWidth; i++) {
    gridX.push(jsx("line", {
      key: i,
      x1: getX(i),
      y1: getY(minY),
      x2: getX(i),
      y2: getY(maxY + 5)
    }));
  }
  const yStep = labelsCountY > 0 ? labelsCountY : unitWidth;
  for (let i = minY; i <= maxY; i += Math.floor(maxY / yStep)) {
    gridY.push(jsx("line", {
      key: i,
      x1: getX(minX),
      y1: getY(i),
      x2: getX(maxX + unitWidth + 0.5),
      y2: getY(i)
    }));
  }
  if (GridLines === 'full') {
    return jsx("g", {
      className: 'DGN-Grid-BarChart',
      stroke: gridColor,
      strokeWidth: gridWidth
    }, gridX, gridY);
  }
  if (GridLines === 'horizontal') {
    return jsx("g", {
      className: 'DGN-Grid-BarChart',
      stroke: gridColor,
      strokeWidth: gridWidth
    }, gridY);
  }
  if (GridLines === 'none') {
    return null;
  } else {
    return jsx("g", {
      className: 'DGN-Grid-BarChart',
      stroke: gridColor,
      strokeWidth: gridWidth
    }, gridY);
  }
};
Grid.propTypes = {
  /** the getX position x on Ox*/
  getX: PropTypes.func,
  /** the getY position y on Oy */
  getY: PropTypes.func,
  /** change color of grid Columb*/
  gridColor: PropTypes.string,
  /** change  Columb grid display style ['full' , 'horizontal', 'none']*/
  GridLines: PropTypes.string,
  /** hiden or  show grid columb*/
  gridVisible: PropTypes.bool,
  gridWidth: PropTypes.number,
  labelsCountY: PropTypes.number,
  /** the maxX is maximum of Ox quantity returned by data*/
  maxX: PropTypes.number,
  /** the maxY is maximum of Oy quantity returned by data*/
  maxY: PropTypes.number,
  /** the minX is minimum of OX quantity returned by data*/
  minX: PropTypes.number,
  /** the minY is minimum of Oy quantity returned by data*/
  minY: PropTypes.number,
  /** the unitWidth */
  unitWidth: PropTypes.number
};
Grid.defaultProps = {
  getX: x => x,
  getY: y => y,
  gridColor: 'rgba(127, 130, 142, 0.15)',
  GridLines: 'full',
  gridVisible: false,
  gridWidth: 0.5,
  labelsCountY: 5,
  unitWidth: 1
};
export default Grid;